var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn-builder',{attrs:{"config":_vm.BTN_CONFIG,"row":_vm.row,"model":_vm.model},on:{"del":function($event){return _vm.$emit('del')}}})}
var staticRenderFns = []

export { render, staticRenderFns }